module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_16_F_1.d4e6420b.mp3";